import { render, staticRenderFns } from "./HorizonalPolicyStatusSelect.vue?vue&type=template&id=86f45c70"
import script from "./HorizonalPolicyStatusSelect.vue?vue&type=script&lang=ts"
export * from "./HorizonalPolicyStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports